import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingGuide/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingGuide/.kr';

export default function SafeDrivingGuide() {
  return (
    <>
      <Environment.Kr>
        <Kr />
      </Environment.Kr>
      <Environment.Eu>
        <Eu />
      </Environment.Eu>
    </>
  );
}
